const API = "https://jm.komerzy.com/backend/?url=perfilapi";

const getToken = () => localStorage.getItem("token");

export const getPerfil = async () => {
  const token = getToken();

  const res = await fetch(`${API}&action=ver`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const json = await res.json();
  return json.data;
};

export const updatePerfil = async (data) => {
  const token = getToken();

  const res = await fetch(`${API}&action=actualizar`, {
    method: "POST",  // <-- CAMBIO A POST
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  return res.json();
};
